import {useState, useEffect, useCallback} from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, {DialogProps} from '@mui/material/Dialog';

import Iconify from 'src/components/iconify';
import {CustomFile, Upload} from 'src/components/upload';
import {fileData, fileDatas} from 'src/minimal-components/file-thumbnail';
import EncryptUtils from 'src/utils/EncryptUtils';
import {postUploadData} from '@shared/services/service-handlers/PrivateService';
import uuidv4 from 'src/utils/uuidv4';
import {LoadingButton} from '@mui/lab';

// ----------------------------------------------------------------------

interface Props extends DialogProps {
  title?: string;
  //
  onCreate?: VoidFunction;
  onUpdate?: VoidFunction;
  //
  folderName?: string;
  onDataUpload?: (file: CustomFile[]) => void;
  //
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: VoidFunction;
}

export default function CMSUpload({
  title = 'Upload Files',
  open,
  onClose,
  //
  onCreate,
  onUpdate,
  //
  folderName,
  onDataUpload,
  ...other
}: Props) {
  const [files, setFiles] = useState<(File | string)[]>([]);
  const [uploadingfile, setUploadingFiles] = useState(false);
  useEffect(() => {
    if (!open) {
      setFiles([]);
    }
  }, [open]);
  const uploadFileToServer = async (file: any) => {
    try {
      const id = uuidv4();
      const {type, name} = fileData(file) || {
        type: ''
      };
      console.log('type', type, name);
      const filename = name && name.split('.').pop();
      console.log(id);
      const reqPayload = EncryptUtils.encryptedData({
        userId: `${id}.${filename}`
      });
      const formData = new FormData();
      if (file && type) {
        formData.append('file', file);
        formData.append('tk', reqPayload);
      } else {
        formData.append('file', file);
        formData.append('tk', reqPayload);
      }
      const response = await postUploadData(
        'LMS',
        'module',
        formData,
        'uploadFile'
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };
  console.log('files', files);

  const handleDrop = useCallback(
    async (acceptedFiles: File[]) => {
      // const newFiles = await Promise.all(
      //   acceptedFiles.map(async file =>
      //     Object.assign(file, {
      //       preview: await uploadFileToServer(file)
      //     })
      //   )
      // );

      setFiles([...files, ...acceptedFiles]);
    },
    [files, setFiles]
  );

  const handleUpload = async () => {
    try {
      setUploadingFiles(true);
      const newFiles: CustomFile[] = await Promise.all(
        files.map(async file => {
          if (file instanceof File) {
            console.log('filefile', file);
            const preview = await uploadFileToServer(file);
            return {
              name: file.name,
              size: file.size,
              type: file.type,
              lastModified: file.lastModified,
              preview, // Add your custom property
              path: file.webkitRelativePath || file.name // Add a path if available
            } as CustomFile;
          } else {
            throw new Error('Invalid file type');
          }
        })
      );
      setFiles(newFiles);
      setUploadingFiles(false);
      if (newFiles) {
        onDataUpload?.(newFiles);
      }
      onClose();
      console.info('ON UPLOAD');
    } catch (e) {
      setUploadingFiles(false);
    }
  };

  const handleRemoveFile = (inputFile: File | string) => {
    const filtered = files.filter(file => file !== inputFile);
    setFiles(filtered);
  };

  const handleRemoveAllFiles = () => {
    setFiles([]);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{p: theme => theme.spacing(3, 3, 2, 3)}}>
        Upload Files
      </DialogTitle>

      <DialogContent dividers sx={{pt: 1, pb: 0, border: 'none'}}>
        <Upload
          multiple
          files={files}
          onDrop={handleDrop}
          onRemove={handleRemoveFile}
        />
      </DialogContent>

      <DialogActions>
        <LoadingButton
          loading={uploadingfile}
          variant="contained"
          startIcon={<Iconify icon="eva:cloud-upload-fill" />}
          onClick={handleUpload}>
          Upload
        </LoadingButton>

        {!!files.length && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleRemoveAllFiles}>
            Remove all
          </Button>
        )}
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => {
            handleRemoveAllFiles();
            onClose();
          }}>
          Cancel
        </Button>
        {/* {(onCreate || onUpdate) && (
          <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
            <Button variant="soft" onClick={onCreate || onUpdate}>
              {onUpdate ? 'Save' : 'Create'}
            </Button>
          </Stack>
        )} */}
      </DialogActions>
    </Dialog>
  );
}
